<template>
  <app-text-input
      v-bind="$attrs"
      v-on="$listeners"
      :name="name"
      :rules="getRules"
      :value="value"
      maxlength="10"
      :counter="false"
  />
</template>

<script>
export default {
  name: 'IdentityInput',
  props: {
    name: {
      required: true
    },
    value: {},
    rules: {
      type: [Array, String],
      default: () => 'identity'
    }
  },
  computed: {
    getRules() {
      return this.rules || 'identity';
    }
  }
};
</script>
